import {observable, action, runInAction} from 'mobx'
import {get} from '../../../../utils/ajax'
import {message} from "antd/lib/index";
import {handleSeerchAndPage} from "../../../../utils/Utils";

class ToolListStore {
    @observable loading;
    @observable List;
    @observable carList;
    @observable values;
    @observable page;

    constructor() {
        this.loading = false
        this.List = [];
        this.carList = [];
        this.values = '';
        this.page = {
            current: 0,
            total: 1
        }
    }

    /*** 根据条件或无条件分页请求接口加载数据*/
    @action
    initPage = async (temPage, value) => {
        runInAction(() => {
            this.loading = true
        });
        let search = handleSeerchAndPage(temPage, this.page, {carseriesId: value || ''})
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/components/beforeShoppingList`, search);
        if (res && res.status === 0) {
            message.error(res.msg)
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.List = res.content || [];
            this.loading = false;
            this.page = {
                current: res.number + 1,
                total: res.totalElements
            }
        })
    }

    /*** 初始化车系列表*/
    @action
    initCarseries = async () => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/carseriesCatalog/receptionList`);
        runInAction(() => {
            this.carList = res.content || [];
        })
    }
}

export default new ToolListStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/toolkit/ToolList/store.js